__turbopack_context__.v({
  "eyebrow": "BlockSignUpForm-module-scss-module__N6bHTa__eyebrow",
  "header": "BlockSignUpForm-module-scss-module__N6bHTa__header",
  "headline": "BlockSignUpForm-module-scss-module__N6bHTa__headline",
  "root": "BlockSignUpForm-module-scss-module__N6bHTa__root",
});
